import styled, { css } from 'styled-components';
import Typography from '@klv/atoms/typography';

import { translateCard } from '@klv/shared/utils/translateCard';
import { GradientText } from '../../../atoms/gradient-text';
import { Card } from '../../../molecules/social-card/styles';
import Buttons from '@klv/molecules/buttons';

export const Title = styled(Typography)`
  ${({ theme }) => css`
    ${theme.fonts.sohne.light}
    grid-column: 1 / -1;
    text-align: center;
    color: ${theme.colors.white};
    font-size: 2.4rem;
    line-height: 1.4;
    width: 60%;
    margin: auto;
    margin-top: 4.8rem;
    margin-bottom: 4.8rem;

    ${theme.screenSize.s576.mediaQuery} {
      font-size: 2.8rem;
      width: 75%;
    }
    ${theme.screenSize.s768.mediaQuery} {
      font-size: 3.2rem;
      margin-top: 7.2rem;
      width: 65%;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      font-size: 3.6rem;
      line-height: 1.15;
      margin-top: 6.4rem;
      margin-bottom: 6.4rem;
      width: 60%;
    }
    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 3.6rem;
    }
    ${theme.screenSize.s1366.mediaQuery} {
      width: 50%;
    }
  `}
  
  strong {
    ${GradientText}
    font-weight: 300;
  }
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    padding-bottom: 4.8rem;
    ${theme.screenSize.s768.mediaQuery} {
      padding-bottom: 7.2rem;
    }
    ${theme.screenSize.s1024.mediaQuery} {
      padding-bottom: 6.4rem;
    }
  `}
`;

export const SocialCardWrapper = styled.div`
  ${({ theme }) => css`
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    overflow: hidden;
    ${Object.entries(theme.screenSize).map(( size ) => css`
      ${size[1].mediaQuery} {
        width: ${size[1].size > 102.3 ? `${size[1].size}rem` : '100%'};
        padding: 0 ${size[1].size > 102.3 ? `${size[1].gridHorizontalPadding}rem` : 0}; 
      }
    `)}
  `}
`;

export const Social = styled.div<{ $current: number; $cardWidth: number; $windowWidth: number; $resizing: boolean; }>`
  ${({ theme, $windowWidth, $current, $cardWidth, $resizing }) => css`
    ${Card} {
      width: 45.6rem;
      max-width: calc(100vw - 12rem);
    }
    display: flex;
    gap: 2.4rem;
    transform: translateX(${translateCard($windowWidth, $cardWidth, 24, $current)}px);
    transition-property: transform;
    transition-timing-function: ease-in-out;
    transition-duration: ${$resizing ? '0s' : '.5s'};
    ${theme.screenSize.s576.mediaQuery} {
      ${Card} {
        max-width: calc(100vw - 16rem);
      }
    }
    ${theme.screenSize.s1024.mediaQuery} {
      width: 100%;
      gap: 2.1rem;
      ${Card} {
        width: auto;
      }
      transform: translateX(0);
    }
    ${theme.screenSize.s1200.mediaQuery} {
      gap: 2.4rem;
    }
  `}
  @media (prefers-reduced-motion) {
    transition-duration: 0s !important;
  }
`;

export const StyledButtons = styled(Buttons)`
  grid-column: 1/-1;
  margin: 3.6rem auto 0;

  ${({ theme }) => `
    ${theme.screenSize.s768.mediaQuery} {
      grid-column: 5/9;
    }
  `}
`;


export { translateCard };

